import { Standort } from '../models'
import { convertStandortToDto } from '../converters'
import {
  BefehlsnachrichtEindeutigeKennungParts,
  BefehlsnachrichtStandortParts,
  BefehlsnachrichtStatusParts,
  verifyBefehlsnachrichtHash
} from './hash'

export interface VerifiableStatusTimestamp {
  status: string
  time: Date
  visuellerStatus: string
}

// The backend omits zero milliseconds, while toISOString() emits `.000Z`.
// Example: backend `...00Z` vs. frontend `...00.000Z`.
function formatStatusTimestampForHash(time: Date): string {
  return time.toISOString().replace(/\.000Z$/, 'Z')
}

export function verifyEindeutigeKennungHash(
  id: string,
  eindeutigeKennungHash: string,
  eindeutigeKennung: string
): Promise<boolean> {
  return verifyBefehlsnachrichtHash(
    {
      id,
      eindeutigeKennung
    } as BefehlsnachrichtEindeutigeKennungParts,
    eindeutigeKennungHash
  )
}

/**
 * Valid only when standortHash and standort are both absent, or both present
 * and the recalculated hash matches. Setting just one of them is treated as
 * tampering and rejected.
 */
export async function verifyStandortHash(
  id: string,
  standortHash: string | null,
  standort: Standort | null
): Promise<boolean> {
  if (!standortHash && !standort) {
    return true
  }
  return verifyBefehlsnachrichtHash(
    {
      id,
      standort: standort ? convertStandortToDto(standort) : null
    } as BefehlsnachrichtStandortParts,
    standortHash ?? ''
  )
}

export function verifyStatusHash(
  id: string,
  statusHash: string,
  visuellerStatus: string,
  technischerStatus: string,
  statusTimestamps: VerifiableStatusTimestamp[]
): Promise<boolean> {
  return verifyBefehlsnachrichtHash(
    {
      id,
      visuellerStatus,
      technischerStatus,
      statusTimestamps: statusTimestamps.map((ts) => ({
        status: ts.status,
        time: formatStatusTimestampForHash(ts.time),
        visuellerStatus: ts.visuellerStatus
      }))
    } as BefehlsnachrichtStatusParts,
    statusHash
  )
}
